module.exports = __webpack_public_path__ + "img/support_e4.fd7410da.png";